import { useContext, useState } from 'react'
import { PrefillResumeOptions } from '@rio/types'
import { Icon40 } from 'builder/components/Icon'
import { GuestResumeContext } from 'builder/context/GuestResumeContext'
import { useI18n } from 'builder/hooks/useI18n'
import { Recaptcha } from 'builder/components/Recaptcha'
import { FillResumeModalGuest } from '../FillResumeModal'
import { SignUpBuilderGuestModal } from '../SignUpBuilderGuestModal'
import { StepByStepFlowGuest } from './StepByStepFlow/StepByStepFlowGuest'
import { EditorPanel, PreviewButton } from './styles'

const ResumeEditorGuest = () => {
  const { i18n } = useI18n()
  const { resume, updateResumeFields, toggleEmailRequiredError, setFileForPrefill } =
    useContext(GuestResumeContext)
  const { template, showPrefillResumeModal } = resume
  const [registerModalPrefillOption, setRegisterModalPrefillOption] =
    useState<PrefillResumeOptions | null>(null)
  const [isPrefillModalOpened, setIsPrefillModalOpened] = useState(showPrefillResumeModal ?? true)

  const onPrefillModalClose = () => {
    setIsPrefillModalOpened(false)
    updateResumeFields({ showPrefillResumeModal: false })
  }

  const onPrefillModalDisabledItemClick = (type: PrefillResumeOptions, file?: File) => {
    setIsPrefillModalOpened(false)
    setRegisterModalPrefillOption(type)

    if (file) {
      setFileForPrefill(file)
    }
  }

  const onSignUpModalClose = () => {
    setIsPrefillModalOpened(true)
    setRegisterModalPrefillOption(null)
  }

  return (
    <>
      <EditorPanel data-testid="editor-panel">
        <StepByStepFlowGuest />
        {isPrefillModalOpened && (
          <FillResumeModalGuest
            handleClose={onPrefillModalClose}
            handleDisabledItemClick={onPrefillModalDisabledItemClick}
          />
        )}
        {registerModalPrefillOption && template && (
          <SignUpBuilderGuestModal
            templateId={template}
            prefillOption={registerModalPrefillOption}
            onClose={onSignUpModalClose}
          />
        )}
      </EditorPanel>

      <PreviewButton onClick={toggleEmailRequiredError}>
        {i18n.t('builder.sign_up.preview')}
        <Icon40.Document />
      </PreviewButton>

      <Recaptcha />
    </>
  )
}

export default ResumeEditorGuest
